import { Link } from "react-router-dom";
import { useAppSelector } from '../../hooks';
import Logo from "../../assets/images/logo-orientalbank.png";
import { logClickEvent } from "../../utils/NativeWebView";

const TheHeader = () => {

  const handleClickLogo = () => {
    logClickEvent('btn_header', 'click_logo', 'link', 'btn_header');
  };

  const handleClickSettings = () => {
    logClickEvent('settings', 'click_settings', 'settings', 'Settings');
  };

  const { showSettingsInfo } = useAppSelector( state => state.webSettings );

  return (
    <header className="bg-orange w-full py-5 px-12 flex justify-between items-center">
      <Link to="/" onClick={handleClickLogo}>
        <img src={Logo} alt="Oriental Bank logo" />
      </Link>

      { showSettingsInfo && <Link to="/settings" onClick={handleClickSettings} className="text-white opacity-50 font-light">
        <p>show settings</p>
      </Link> }
    </header>
  );
};

export default TheHeader;
